// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login_wrapper__JI-eD","header":"login_header__1nQmK","content":"login_content__19Ww9"};